import { useEffect, useMemo, useState } from "react";
import { Select, Spin, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setHeadings,
  setSubHeadings,
  setselectedTab,
} from "../../../Store/B2bslice";
import NotAvailable from "../../../Routes/NotAvailable";

import CreditCardBillPay from "./CreditCardBillPay";
import { getbillers } from "../../../ApiServices/Apifun";

const BillerDetails = () => {
  const dispatch = useDispatch();
  const { TabPane } = Tabs;
  const { Option } = Select;
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const [allproviders, setAllProviders] = useState([]);
  const [circles, setCircles] = useState([]);
  const [selectLoading, setSelectLoading] = useState(false);
  const [selectedProviders, setSelectedProviders] = useState({});

  const grouped = useMemo(() => {
    return (allproviders || []).reduce((i, item) => {
      const svcName = item.label || "Unknown";
      if (!i[svcName]) {
        i[svcName] = { billerType: item.billerType, providers: [] };
      }
      i[svcName].providers.push(item);
      return i;
    }, {});
  }, [allproviders]);

  const handleSelectChange = (serviceName) => {
    console.log(serviceName, "selectedProviders");

    setSelectedProviders(serviceName);
  };
  const getAllBillers = () => {
    setSelectLoading(true);
    getbillers()
      .then((res) => {
        if (res?.status) {
          setAllProviders(res.data?.billers || []);
          setCircles(res.data?.circles || []);
          setSelectLoading(false);
        } else {
          setAllProviders([]);
        }
      })
      .catch((err) => {
        console.error("getProviders error:", err);
        setAllProviders([]);
      })
      .finally(() => setSelectLoading(false));
  };

  useEffect(() => {
    dispatch(setSubHeadings(""));
    dispatch(setselectedTab("252"));
    dispatch(setHeadings("Credit Card Bill Payment "));
    getAllBillers();
  }, []);

  const hasData = Object.keys(grouped).length > 0;

  if (selectLoading) {
    return (
      <div className="w-full min-h-[200px] flex justify-center items-center">
        <Spin size="large" tip="Loading billers..." />
      </div>
    );
  }
  console.log("serviceName:", circles);

  return (
    <div className="relative min-h-[300px] flex justify-center items-center">
      {selectLoading ? (
        // Spinner shown while API is pending
        <Spin size="large" tip="Loading billers..." />
      ) : (
        // When data is loaded
        <div className="All_services w-full p-4 rounded-md mb-5 gap-4 flex-wrap items-center">
          <Tabs type="line" className="p-4 custom-tabs">
            {Object.entries(grouped)
              .sort(([a], [b]) => a.localeCompare(b))
              .map(([serviceName, { billerType, providers }]) =>
                billerType === "CREDIT_CARD" ? (
                  <Tabs.Tab key={serviceName} title={serviceName}>
                    <div className="w-full mt-4 bg-white p-4 rounded-lg">
                      {/* {console.log(
                        serviceName,
                        billerType,
                        providers,
                        "servuiename"
                      )} */}
                      <CreditCardBillPay
                        billerType={billerType}
                        circles={circles}
                        service_name={serviceName}
                      />
                    </div>
                  </Tabs.Tab>
                ) : null
              )}
          </Tabs>
        </div>
      )}
    </div>
  );
};

export default BillerDetails;
